import type { EventDetail } from "@cdt/shared";

import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";

interface EventAiResponseProps {
  event: EventDetail;
}

function renderPayload(raw: EventDetail["rawAiResponse"]): string {
  if (raw === null) return "";
  if (typeof raw === "string") return raw;
  try {
    return JSON.stringify(raw, null, 2);
  } catch {
    return String(raw);
  }
}

export function EventAiResponse({ event }: EventAiResponseProps) {
  const text = renderPayload(event.rawAiResponse);
  const hasContent = event.rawAiResponse !== null && text.length > 0;

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Risposta AI</CardTitle>
      </CardHeader>
      <CardContent>
        {!hasContent ? (
          <p className="text-sm text-muted-foreground">
            Nessuna risposta AI registrata per questo evento.
          </p>
        ) : (
          <details className="group">
            <summary className="cursor-pointer text-sm font-medium text-primary hover:underline">
              <span className="group-open:hidden">
                Mostra risposta AI grezza
              </span>
              <span className="hidden group-open:inline">
                Nascondi risposta AI grezza
              </span>
            </summary>
            <pre className="mt-3 max-h-[480px] overflow-auto rounded-md border bg-muted/30 p-4 font-mono text-xs whitespace-pre-wrap break-words">
              {text}
            </pre>
          </details>
        )}
      </CardContent>
    </Card>
  );
}
